export default {
    updateForms(state,payload){
        state.forms = payload.data
        state.pagination.page = payload.meta.current_page
        state.pagination.rowsPerPage = payload.meta.per_page
        state.totalItems = payload.meta.total
    },
}
